var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BusinessCard',{attrs:{"packUp":"","identity":"unLoginShare","cardDetail":_vm.cardDetail,"cooperationDetail":_vm.cooperationDetail},on:{"login":_vm.handleLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }